// SPDX-License-Identifier: AGPL-3.0-or-later

import Theme from '@app/features/theme/state/Theme';
import {broadcastThemeStudioMessage} from '@app/features/theme_studio/state/ThemeStudioBroadcast';
import type {ThemeType} from '@fluxer/constants/src/UserConstants';

// KONVO: the theme is per device, so it stays in this device's storage and never goes to the account.
export function updateThemePreference(theme: ThemeType): boolean {
	Theme.setTheme(theme);
	broadcastThemeStudioMessage({type: 'themePreference', snapshot: Theme.getPreferenceSnapshot()});
	return true;
}
